class CartForm extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.inputs = [];
    this.submitButton = null;
    this.cartItems = [];
    this.novaPostInfo = {
      city: "",
      address1: "",
      country: "Ukraine",
    };
    this.isWholesale = this.hasAttribute('data-wholesale');
  }

  #selector = "#cart-form";

  connectedCallback() {
    this.getElements();
    this.addListeners();

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.getElements();
      this.addListeners();
      if (event.source === 'product-form') {
        const cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.refreshCartSections === 'function') {
          cartItems.refreshCartSections();
        }
      } else {
        this.setCartItems(event.parsedState.items);
      }
    });
  }

  getElements() {
    this.form = this.querySelector(this.#selector);
    this.form?.setAttribute("novalidate", "true")
    this.inputs = this.form.querySelectorAll("input, select");
    this.submitButton = this.querySelector(".cart__ctas[type='button']");
  }

  setNovaPostInfo({city = "", address1 = "", province = "", zip = ""}) {
    this.novaPostInfo = {
      ...this.novaPostInfo,
      city,
      address1,
    };
  }

  setCartItems(cartItems) {
    this.cartItems = cartItems;
  }

  addListeners() {
    if (this._listenersAdded) return;
    this._listenersAdded = true;
    
    if (!this.form) return;

    this.form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (!this.validateForm()) {
        return;
      }

      try {
        document.querySelector('#CartDrawer-Checkout-new').disabled = true;
        const cartItems = this.cartItems.map(({quantity, variant_id, final_price, discounts, title, sku, handle, properties}) => {
          const price = this.isWholesale ? (properties?._wholesalePrice ?? 0) : final_price;
          return {
            id: variant_id,
            quantity,
            final_price: (price / 100).toFixed(2),
            discounts,
            title,
            sku,
            handle
          };
        });

        const inputsValues = Array.from(this.inputs).map((input) => ({
          value: input.value,
          inputName: input.getAttribute("name"),
        }));
        const body = {
          listProduct: cartItems,
          ...this.novaPostInfo,
          firstName: inputsValues.find((input) => input.inputName === "firstName").value ?? "",
          lastName: inputsValues.find((input) => input.inputName === "lastName").value ?? "",
          email: inputsValues.find((input) => input.inputName === "email").value ?? "",
          phone: inputsValues.find((input) => input.inputName === "phone").value ?? "",
          paymentMethod: inputsValues.find((input) => input.inputName === "payment-method")?.value ?? "",
          newPostDelivery: document.querySelector('[name="new-post-delivery"]:checked')?.value ?? "",
          noPhoneCall: document.querySelector('[name="no-phone-call-checkbox"]')?.checked ?? false,
          clientEmail: this.isWholesale ? "LS19760802@gmail.com" : "",
        };
        console.log(body);
        
        const fetchUrl = this.isWholesale ? 'https://babolat-shopify-production.up.railway.app/send-babolat-email' : 'https://shopify-1c-sync-production.up.railway.app/nova-pay-babolat';

        const request = await fetch(`${fetchUrl}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
          redirect: "follow"
        });
        const response = await request.json();
        console.log("response: ", response);

        function cartClear(redirectTo) {
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          .then(res => res.json())
          .then(() => {
            window.location.href = `${redirectTo}`;
          })
          .catch(err => {
            console.error('Cart clear failed:', err);
          });
        }

        if (this.isWholesale) {
          if (response.success) {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            const modal = document.querySelector('#PopupModal-wholesale-success');
            modal.show();

            document.body.addEventListener('modalClosed', cartClear('/'));
          }
        } else {
          if (response.data.discounts && response.data.discounts.length > 0) {
            const cartDiscount = document.querySelector('cart-discount');
            cartDiscount.showError(cartDiscount.error.dataset.notValid || 'Discount code not found.');
          } else {
            cartClear(response.data.url);
          }
        }
      } catch (error) {
        console.warn(error);
      }
    });

    this.inputs.forEach((input) => {
      const onLiveInput = (e) => {
        const {errorMessage, isValid} = this.validate(e.target);
        if (errorMessage != "" && isValid == false) {
          this.showErrorMessage(input, errorMessage);
        } else {
          this.hideErrorMessage(input);
        }
      };

      const onFirstBlur = (e) => {
        const {errorMessage, isValid} = this.validate(e.target);
        if (errorMessage != "" && isValid == false) {
          this.showErrorMessage(input, errorMessage);
        } else {
          this.hideErrorMessage(input);
        }
        input.addEventListener("input", onLiveInput);
      };

      input.addEventListener("blur", onFirstBlur, {once: true});
    });
  }

  getErrorMessage(inputName) {
    let message = "";
    switch (inputName) {
      case "firstName":
        message = "Введіть коректне ім'я";
        break;
      case "lastName":
        message = "Введіть коректне прізвище";
        break;
      case "email":
        message = "Введіть коректний email";
        break;
      case "phone":
        message = "Введіть коректний номер телефону";
        break;
      default:
        message = "Введіть коректні дані";
        break;
    }
    return message;
  }

  validateForm() {
    let isFormValid = true;
    this.inputs.forEach((input) => {
      const {errorMessage, isValid} = this.validate(input);
      if (!isValid) {
        this.showErrorMessage(input, errorMessage);
        isFormValid = false;
      } else {
        this.hideErrorMessage(input);
      }
    });
    return isFormValid;
  }

  validate(input) {
    const inputType = input.getAttribute("type");
    const inputName = input.getAttribute("name");
    const inputValue = input.value;

    let errorMessage = "";
    const nameValidation = /^[A-Za-zА-Яа-яЇїІіЄєҐґ'-]{2,30}$/;
    const emailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneValidation = /\d{10,}/;
    let isValid = true;

    switch (inputType) {
      case "text":
        isValid = nameValidation.test(inputValue);
        break;
      case "email":
        isValid = emailValidation.test(inputValue);
        break;
      case "tel":
        isValid = phoneValidation.test(inputValue);
        break;
    }

    if (!isValid) {
      errorMessage = this.getErrorMessage(inputName);
    }

    return {errorMessage, isValid};
  }

  showErrorMessage(input, errorMessage) {
    const element = input?.previousElementSibling;
    if (element) {
      element.textContent = errorMessage;
    }
  }

  hideErrorMessage(input) {
    const element = input?.previousElementSibling;
    if (element) {
      element.textContent = "";
    }
  }

  submit() {
    console.log(this.form);
    this.form.requestSubmit();
  }
}

if (!window.customElements.get("cart-form")) {
  window.customElements.define("cart-form", CartForm);
}
